import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const InlineForwardIcon = ({ sx, ...props }: Props) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'white', ...sx }} {...props}>
    <path
      d="M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z"
      fill="inherit"
    />
  </SvgIcon>
)

InlineForwardIcon.defaultProps = {
  sx: null,
}
